import {
  type AdminSupplierSettings,
  type UpdateSupplierSettingsInput,
  updateSupplierSettingsInputSchema,
} from '@repo/api-contracts';

export const SUPPLIER_FIELDS = [
  'businessNumber',
  'companyName',
  'representativeName',
  'address',
  'businessType',
  'businessItem',
  'contactName',
  'contactEmail',
  'contactPhone',
  'bank',
  'account',
  'holder',
] as const;
export type SupplierSettingsFormValues = Record<(typeof SUPPLIER_FIELDS)[number], string>;
export type SupplierSettingsFormErrors = Partial<Record<keyof SupplierSettingsFormValues, string>>;
export type SupplierSettingsFormResult =
  | { ok: true; input: UpdateSupplierSettingsInput }
  | { ok: false; errors: SupplierSettingsFormErrors };

export const supplierSettingsFormFrom = (
  settings: AdminSupplierSettings,
): SupplierSettingsFormValues => ({
  businessNumber: settings.businessNumber ?? '',
  companyName: settings.companyName ?? '',
  representativeName: settings.representativeName ?? '',
  address: settings.address ?? '',
  businessType: settings.businessType ?? '',
  businessItem: settings.businessItem ?? '',
  contactName: settings.contactName ?? '',
  contactEmail: settings.contactEmail ?? '',
  contactPhone: settings.contactPhone ?? '',
  bank: settings.bank?.bank ?? '',
  account: settings.bank?.account ?? '',
  holder: settings.bank?.holder ?? '',
});

export const parseSupplierSettingsForm = (
  values: SupplierSettingsFormValues,
): SupplierSettingsFormResult => {
  const { bank, account, holder, ...supplier } = values;
  const parsed = updateSupplierSettingsInputSchema.safeParse({
    ...supplier,
    bank: { bank, account, holder },
  });
  if (parsed.success) return { ok: true, input: parsed.data };
  const errors: SupplierSettingsFormErrors = {};
  for (const field of SUPPLIER_FIELDS) {
    const issue = parsed.error.issues.find((item) =>
      item.path[0] === 'bank' ? item.path[1] === field : item.path[0] === field,
    );
    if (!issue) continue;
    if (field === 'businessNumber' || field === 'account' || field === 'contactPhone')
      errors[field] = issue.message;
    else if (field === 'contactEmail') errors[field] = '올바른 이메일 주소를 입력해 주세요.';
    else errors[field] = '값을 입력하고 허용된 길이를 확인해 주세요.';
  }
  return { ok: false, errors };
};
